var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88509 0.923828C6.91263 0.923828 5.98 1.31014 5.29237 1.99777C4.60473 2.6854 4.21842 3.61803 4.21842 4.59049C4.21842 5.56296 4.60473 6.49559 5.29237 7.18322C5.98 7.87085 6.91263 8.25716 7.88509 8.25716C8.85755 8.25716 9.79018 7.87085 10.4778 7.18322C11.1654 6.49559 11.5518 5.56296 11.5518 4.59049C11.5518 3.61803 11.1654 2.6854 10.4778 1.99777C9.79018 1.31014 8.85755 0.923828 7.88509 0.923828ZM12.4684 10.0905H3.30176C2.57241 10.0905 1.87294 10.3802 1.35721 10.896C0.841489 11.4117 0.551758 12.1111 0.551758 12.8405C0.551758 14.8865 1.39326 16.5255 2.77376 17.6347C4.13226 18.7255 5.95459 19.2572 7.88509 19.2572C9.81559 19.2572 11.6379 18.7255 12.9964 17.6347C14.3751 16.5255 15.2184 14.8865 15.2184 12.8405C15.2184 12.1111 14.9287 11.4117 14.413 10.896C13.8972 10.3802 13.1978 10.0905 12.4684 10.0905Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.ef16a5e050cc17fa5120a80ef8b231df.svg";
export { ForwardRef as ReactComponent };